// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget"}[chunkId] + "." + {"231":"7f853693088de6509790","263":"24b84569117ef2e056ed"}[chunkId] + ".js";
};